import { createStore } from 'vuex'
import createHttp from "@/services/http";
import router from "@/router";

export default createStore({
  state: {
    token: "",
    role: "",
    expiration: 0,
    isBusy: false,
    error: "",
    translates: {},
    appSettings: {},
    userlanguage: 'EN',
    userGuid: "",
    userNameSurname: "",
  },
  created() {
    // console.log('KLIČEM CREATED OD STORE!!!!')
  },  
  mutations: { 
    initialiseStore(state) { 

      function base64UrlDecode(str) {
        const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
        const padding = '='.repeat((4 - (base64.length % 4)) % 4);
        const base64WithPadding = base64 + padding;
        return JSON.parse(atob(base64WithPadding));
      };

      function decodeJwt(jwt) {
        const [headerB64Url, payloadB64Url] = jwt.split('.');
        const header = base64UrlDecode(headerB64Url);
        const payload = base64UrlDecode(payloadB64Url);
      
        return {
          header: header,
          payload: payload,
        };
      };

      function replaceYUCharacters(str) {
        let tmpStr = str.replace(/\[\[C\]\]/g,'Č')
          .replace(/\[\[c\]\]/g,'č')
          .replace(/\[\[S\]\]/g,'Š')
          .replace(/\[\[s\]\]/g,'š')
          .replace(/\[\[Z\]\]/g,'Ž')
          .replace(/\[\[z\]\]/g,'ž')
          .replace(/\[\[Dj\]\]/g,'Đ')
          .replace(/\[\[dj\]\]/g,'đ')
          .replace(/\[\[CC\]\]/g,'Ć')
          .replace(/\[\[cc\]\]/g,'ć');

          return tmpStr;
      };

    // console.log('initialiseStore !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!')

    debugger;
    const tmpToken = localStorage.getItem('token');

    let tokenData = tmpToken != null && decodeJwt(tmpToken);
    let hasOperatorTag = false;
    
    if(tokenData) {
      hasOperatorTag = tokenData.payload.hasOwnProperty('OperatorOnly');
    }
    
    let isOperatorTagValue = false;

    if(hasOperatorTag) {
      isOperatorTagValue = tokenData.payload.OperatorOnly == true;
    }

    let isOperator = tokenData && isOperatorTagValue; //tokenData.payload.hasOwnProperty('OperatorOnly');
    // console.log(tokenData);

    debugger;
    if(tokenData) {
      // console.log('TOKEN PAYLOAD:',tokenData.payload);
      state.userGuid = tokenData.payload.Uid;
      state.userNameSurname = replaceYUCharacters(tokenData.payload.Name);
    }
      
    let tmlLanguage = localStorage.getItem('language');
    
    if(tmlLanguage != null)
      state.userlanguage = tmlLanguage;
    else
      state.userlanguage = "SR";


    //const tmpRole = localStorage.getItem('role')
    const tmpExp = localStorage.getItem('expiration')
    // console.log(tmpToken)
    // console.log(state)

    if(tmpToken && !isOperator) {
      
      // console.log('initialiseStore PREBRAL TOKEN')
      // console.log(tmpToken)
      // console.log(tmpExp)
      
      state.token = tmpToken
      //state.role = tmpRole
      state.expiration = tmpExp                
    } else {
      // console.log('initialiseStore NI TOKENA')
    }     

     
    },
    setBusy(state) {
      state.isBusy = true
    },
    clearBusy(state) {
       state.isBusy = false
    },
    setError: (state, error) => state.error = error,
    clearError: (state) => state.error = "",
    setUserlanguage(state,language) {
      debugger;
      // console.log('Prisel v setUserlanguage');    
      
      if(state.userlanguage != language) {
        state.userlanguage = language;
        localStorage.setItem('language', language);
      }
        

      // console.log(state.userlanguage);
    },    
    setTranslates(state,trans) {
      // console.log('Prisel v setTranslates');      
      state.translates = trans;
      // console.log(state.translates);
    },
    setToken(state, model) {
      
      function base64UrlDecode(str) {
        const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
        const padding = '='.repeat((4 - (base64.length % 4)) % 4);
        const base64WithPadding = base64 + padding;
        return JSON.parse(atob(base64WithPadding));
      };

      function decodeJwt(jwt) {
        const [headerB64Url, payloadB64Url] = jwt.split('.');
        const header = base64UrlDecode(headerB64Url);
        const payload = base64UrlDecode(payloadB64Url);
      
        return {
          header: header,
          payload: payload,
        };
      };

      function replaceYUCharacters(str) {
        let tmpStr = str.replace(/\[\[C\]\]/g,'Č')
          .replace(/\[\[c\]\]/g,'č')
          .replace(/\[\[S\]\]/g,'Š')
          .replace(/\[\[s\]\]/g,'š')
          .replace(/\[\[Z\]\]/g,'Ž')
          .replace(/\[\[z\]\]/g,'ž')
          .replace(/\[\[Dj\]\]/g,'Đ')
          .replace(/\[\[dj\]\]/g,'đ')
          .replace(/\[\[CC\]\]/g,'Ć')
          .replace(/\[\[cc\]\]/g,'ć');

          return tmpStr;
      };
      
      // console.log('Prisel v SetToken')
      // console.log(model);

      const exp = new Date(model.expiration)
      const expNumber = Number(exp)

      // console.log('expiration number:' + expNumber)
      // console.log('SHRANJUJEM TOKEN')

      // prvo shranim v peristent store      
      localStorage.setItem('token', model.token);
      // localStorage.setItem('role', model.Role);
      localStorage.setItem('expiration', expNumber);

      // sedaj se v persistent object
      state.token = model.token
      //state.role = model.Role
      state.expiration = expNumber

      debugger;
      // console.log('SetToken funkcija')
      // console.log('token::' + state.token)
      // console.log('expiration:' + state.expiration)
      
      let tokenData = decodeJwt(state.token);
      let isOperator = tokenData && tokenData.payload.hasOwnProperty('OperatorOnly');
  
      // console.log('TOKEN DATA: ',tokenData)
      debugger;
      if(tokenData) {
        state.userGuid = tokenData.payload.Uid;
        state.userNameSurname = replaceYUCharacters(tokenData.payload.Name);
      }


    },
    clearToken(state) {
      // console.log('clearToken BEGIN')
      localStorage.removeItem('token')
      //localStorage.removeItem('role')
      localStorage.removeItem('expiration')
      state.token = "";
      state.role = "";
      state.expiration = Date.now();
    },
    setForgotPasswordResult(state, result) {
      state.forgotPasswordResult = result;
    },

  },
  getters: {
    isAuthenticated: (state) => {
            
        debugger;
        // console.log('isAuthenticated BEGIN')
        const isAuth = state.token.length > 0 && state.expiration > Date.now()
        const dateCheck = state.expiration > Date.now()
        
        // console.log(state.token.length)
        // console.log(state.expiration)
        // console.log(Date.now())
        // console.log('IsAuth: ' + isAuth)
        // console.log('DateCheck: ' + dateCheck)
        // console.log('isAuthenticated END') 
        
        return isAuth && dateCheck;
    },
    getToken: (state) => {
       // console.log('GetToken: ' + state.token);
       return state.token;
     },    
    getRole: (state) => {
      // console.log('Role: ' + state.role);
      return state.role;
    },
    isInRole: (state) => (roleName) => {
      return true;
      /*
       // console.log('isInRole: ' + state.role + ' ' + roleName);
       return state.role.includes(roleName);
       */
     },    
    getUserlanguage: (state) => {
      debugger;
      // console.log('User language: ' + state.userlanguage);
      return state.userlanguage;
    },     
    getUserId: (state) => {
      debugger;
      // console.log('getUserId');
      // console.log(state.userGuid);
      return state.userGuid;
    },   
    getTranslate: (state) => (key) => {
      /*
      // console.log('Iscem podatek za translate');
      // console.log(state.userlanguage + '-' + key);
      // console.log(state.translates);
      */
     // debugger;
      const translatedValue = state.translates[state.userlanguage + '-' + key];
      if(translatedValue != undefined) {
        // console.log(translatedValue.translateValue);
        return translatedValue.translateValue;
      }
      
      return '';
      
    },
    getForgotPasswordResult: (state) => {
      return state.forgotPasswordResult;
    }
  }, 
  actions: {
    InitMyStore: ( { commit } ) => {
      // console.log('InitMyStore !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!')

// 'https://ncup-www.geoprostor.net/prometejapi'
      const http = createHttp(false);
      // console.log('klicem server na LOKACIJI:'); 
debugger;
      let tmpUrl = process.env.VUE_APP_API_FOLDER + "/GetTranslates";
      // console.log(tmpUrl);
      // // console.log(process.env);
      http.get(tmpUrl)
      .then(response => {
        // console.log('Tole sem dobil nazaj od serverja:');
        // console.log(response);
        if (response.status == 200) {
          // console.log('Dobil translate podatke');
          // console.log('Set user language na SR');
         // commit("setUserlanguage", 'SR');
          commit("setTranslates", response.data);
          
          // console.log('TRANSLATES !!!');
          // console.log(response.data);
        }        
      }).catch(({response}) => {
        
          // console.log('napaka od get translates');
          // console.log(response);
          
      }).finally(() => {
        // console.log('TULE PA NADALJUJEM');

      });

    },
    setNewLanguage: ( { commit }, model ) => {
      debugger;

        commit("setUserlanguage", model.Language);

      
    },
    login: async ({ commit }, model) => {
      try {
        debugger;
        // commit("setUserlanguage", model.Language);

        // console.log('login START ************** NEW ******************')
        commit("setBusy");
        commit("clearError");
        const http = createHttp(false); // unsecured

        if(http.headers==null) {
            // console.log('NIMAM headerje')
            http.headers = {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Credentials': 'true'
            }
            
            
            //{ 'Content-Type': 'application/json' }
        }
        //http.headers['Content-Type'] = 'application/json'
        
        // console.log('Store.login')
        // console.log(http.headers)
        // console.log(model)
        
        // 'https://ncup-www.geoprostor.net/prometejapi'
        const loginurl = process.env.VUE_APP_AUTH_FOLDER + "/login";
        
        // console.log('LOGIN URL');
        // console.log(loginurl);        


        const result = await http.post(loginurl, model);
        const redirectUrl = localStorage.getItem('redirectUrl');

        // console.log(model);
        // console.log('koncal request!')
        // console.log(result)
        
        if (result.data.success) {
          // console.log(result.data)
          commit("setToken", result.data);
          if (redirectUrl) {
            localStorage.removeItem('redirectUrl')
            router.push(redirectUrl)
          } else {
            sessionStorage.clear();
            router.push("/");
          }
        }
        else {
          commit("setError", "Neuspesno logovanje");
        }
        
      } catch (error) {
        // console.log('ERROR !!! Koncal request!')
        commit("setError", "Problem sa logovanjem");
      } finally {
        commit("clearBusy");
      }
      
    },
    forgotPassword: async ({ commit }, model) => {
      try {
        debugger;
        // console.log('forgotPassword START ************** NEW ******************')
        commit("setBusy");
        commit("clearError");
        const http = createHttp(false); // unsecured

        if(http.headers==null) {
            // console.log('NIMAM headerje')
            http.headers = {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Credentials': 'true'
            }
            
            
            //{ 'Content-Type': 'application/json' }
        }
        //http.headers['Content-Type'] = 'application/json'
        
        // console.log('forgotPassword Store.login')
        // console.log(http.headers)
        // console.log(model)
        
        // 'https://ncup-www.geoprostor.net/prometejapi'
        const loginurl = process.env.VUE_APP_AUTH_FOLDER + "/requestNewPassword";
        
        // console.log('LOGIN URL');
        // console.log(loginurl);        


        let postData = { email: model };
        const result = await http.post(loginurl, postData);
        
        // console.log(model);
        // console.log('koncal request!')
        // console.log(result)
        
        debugger;
        if (result.data.status == 'OK') {
          // console.log(result.data)
          // commit("setToken", result.data);
          //router.push("/");
          commit('setForgotPasswordResult', true);
        }
        else {
          commit("setError", "Korisnik nije pronađen, molimo proverite korisničko ime");
          commit('setForgotPasswordResult', false);
        }
        
      } catch {
        // console.log('ERROR !!! Koncal request!')
        commit("setError", "Korisnik nije pronađen, molimo proverite korisničko ime.");
        commit('setForgotPasswordResult', false);
      } finally {
        commit("clearBusy");
      }
      
    },    
    logout: ({ commit }) => {
      debugger;
      sessionStorage.clear();
      commit("clearToken");
      router.push("/login");
    }
  }
})